//#region Util Imports

import * as moment from 'moment'
import * as _ from 'underscore'

//#endregion

//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region DevExtreme Imports

import DataSource from 'devextreme/data/data_source'
import DevExpress from 'devextreme'

//#endregion

//#region IMR Imports

import { IMRToastHiddenArgs, IIMRToast } from '@imr/controls.angularjs/services/toast'

//#endregion

import { GridRequestModel, ColumnModel } from '../api/api.models'

import { GetViewColumnOptions, OpView } from '../../models/core/op-view'
import { Enums } from '../../models/common/enums'

import { ActionService } from '../../services/action'
import { GridService } from '../../services/grid'
import { DetailsOptions, SystemService } from '../../services/system'
import { Api, LocalDictionaryFactory } from '../api/api.module'

import { EventsNames } from '../../helpers/events-names'
import { CommonHelper, DataType } from '../../helpers/common-helper'
import { RequestManager } from '../../helpers/request-manager'
import { IUserSession } from '../../helpers/user-session'
import { ToastHelper } from '../../helpers/toast-helper'
import { LocalizationHelper, TypeHelper, ConvertHelper } from '../../helpers'

import { BaseGridController } from '../common/common.base.grid.controller'
import { ScopeBaseGrid } from '../common/common.base.grid.controller'
import { TreeListController, TreeListOptions } from '../common/tree-list/tree-list.controller'
import { AdditionalFilter, ButtonsOptions, GridTypes } from '../common/grid/grid.controller'
import { Activity } from '../../models/common'
import { ColumnInfo } from '../../models/custom'
import { OpAction, OpViewColumn } from '../../models/core'
import { DataProviderListResult } from '../../data-provider'
import { ActionSelectedFilters, IIMRActionFilters, IMRActionFiltersInitializedArgs } from '../common/action-filters/action-filters.interfaces'
import { OperatorLayoutSetting } from '../../models/local'
import ArrayStore from 'devextreme/data/array_store'

interface ActionsScope extends ScopeBaseGrid {
    mainTreeListOptions: TreeListOptions
    showGrid: boolean
    filtersInfoPopoverOptions: DevExpress.ui.dxPopoverOptions

    CHANGE_FILTER_POPOVER_TEXT: string
}

export class ActionsController extends BaseGridController {
    private get TREE_LIST_NAME(): string { return 'ActionsTreeList' }
    private get PARENT_ID_FIELD(): string { return 'parentId' }

    private pageSize: number = 2000
    private grid: TreeListController<OpAction>
    private treeListId: number
    private requestState: any = {}
    private selectedFilters: ActionSelectedFilters
    private columns: ColumnModel[]
    private actionFiltersComponent: IIMRActionFilters
    private filtersInfoPopover: DevExpress.ui.dxPopover

    constructor(
        public $scope: ActionsScope,
        protected $state: StateService,
        protected $timeout: ng.ITimeoutService,
        private $q: ng.IQService,
        protected api: Api,
        protected localDictionary: LocalDictionaryFactory,
        protected systemService: SystemService,
        protected userSession: IUserSession,
        private actionService: ActionService,
        private gridService: GridService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, null, referenceType)

        this.setFilters()
        this.setDateRangeFilters()
        this.setEvents()
        this.setOptions()
        this.setConstants()
    }

    //#region Events

    private setEvents(): void {
        this.$scope.$on(EventsNames.FILTERS_CLEARED, () => {
            this.selectedFilters = <ActionSelectedFilters>{}

            this.$state.params['ids'] = null

            this.resetDate()
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionType), null)
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionState), null)
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionOperator), null)
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionDeviceId), null)
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionLocationId), null)
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionMeterId), null)
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionModule), null)

            this.getActionsWithTreeListRefresh()

            if (this.actionFiltersComponent != null) {
                this.actionFiltersComponent.filtersClearedRedirect()
            }
        })
    }

    private onActionFiltersCancel(): void {
        if (this.requestState.request != null && this.requestState.request.$resolved == null) {
            RequestManager.cancelRequest(this.requestState)
        }

        this.mockGetActionMethodAndRefreshGrid()
    }

    private onActionFiltersUpdated(selectedFilters: ActionSelectedFilters): void {
        this.selectedFilters = selectedFilters || <ActionSelectedFilters>{}
        this.getActionsWithTreeListRefresh()
    }

    private onTreeListInitialized(e: any, grid: TreeListController<OpAction>): void {
        this.treeListId = e.tableId
        this.dataGrid = e.component
        this.grid = grid
    }

    private onTreeListNodeInitialized(e: any): void {
        if (this.dataGrid != null) {
            e.root.children.forEach((child: any) => {
                this.dataGrid.collapseRow(child.key)
            })
        }
    }

    private onTreeListContentReady(e: any): void {
        if (this.$state.params['ids'] && this.$state.params['ids'].length > 0 && this.$state.params['ids'].length > e.component.totalCount()) {

            this.$timeout(() => {
                this.openChangeFiltersToast()

                this.filtersInfoPopover.show(`#${TreeListController.ACTION_FILTERS_HTML_TARGET_ID}` + this.treeListId)

                this.$timeout(() => {
                    this.filtersInfoPopover.hide()
                }, 10000)
            })
        }
    }

    private onShowDetails(e: any): void {
        const detailsOptions: DetailsOptions = {
            hasPermission: true,
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            pageItemsIds: this.grid.pageItemsIds,
            referenceObjectId: this.grid.selectedItemId
        }

        this.showDetails(e, detailsOptions)
    }

    //#endregion


    //#region Options

    private setOptions(): void {
        this.setFiltersInfoPopoverOptions()
    }

    private setFiltersInfoPopoverOptions(): void {
        this.$scope.filtersInfoPopoverOptions = {
            onInitialized: (e: any) => {
                this.filtersInfoPopover = e.component
            },
            position: 'left',
            maxHeight: 60,
            width: 300,
            animation: {
                hide: {
                    type: 'fadeOut'
                },
                show: {
                    type: 'fadeIn'
                }
            }
        }
    }

    private getButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,
            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ACTION_LIST) ? "['" + Activity[Activity.ACTION_LIST] + "']" : null,
            deletePermissions: null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,

            onShowClick: (e: any) => {
                this.onShowDetails(e)
            }
        }
    }

    //#endregion


    //#region Setup

    private setFilters(): void {
        this.selectedFilters = <ActionSelectedFilters>{}

        this.selectedFilters.selectedType = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionType), null)
        this.selectedFilters.selectedState = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionState), null)
        this.selectedFilters.selectedOperator = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionOperator), null)
        this.selectedFilters.selectedDevice = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionDeviceId), null)
        this.selectedFilters.selectedLocation = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionLocationId), null)
        this.selectedFilters.selectedMeter = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionMeterId), null)
        this.selectedFilters.selectedModule = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionModule), null)
    }

    private setDateRangeFilters(): void {
        this.$scope.$root['dateFormatsDefer'].promise.then(() => {
            const dateFormat: string = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')

            let date: Date = new Date()
            date.setHours(0, 0, 0, 0)

            const fromDate: Date = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionFromDate), null)
            if (fromDate == null) {
                this.selectedFilters.selectedFromDate = moment(date.setDate(date.getDate() - 6)).format(dateFormat)
            } else {
                this.selectedFilters.selectedFromDate = moment(fromDate, dateFormat).format(dateFormat)
            }

            date = new Date()
            date.setHours(23, 59, 59, 999)

            const toDate: Date = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionToDate), null)
            if (toDate == null) {
                this.selectedFilters.selectedToDate = moment(date).format(dateFormat)
            } else {
                this.selectedFilters.selectedToDate = moment(toDate, dateFormat).format(dateFormat)
            }

            this.drawGrid()
        })
    }

    private prepareCustomWhereClause(actionView: OpView, columns: ColumnModel[]): string {
        const dateFormat = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')
        const fromDate = moment(this.selectedFilters.selectedFromDate, dateFormat).format('YYYY-MM-DD HH:mm')
        const toDate = moment(this.selectedFilters.selectedToDate, dateFormat).format('YYYY-MM-DD HH:mm')
        const idType = this.selectedFilters.selectedType ? this.selectedFilters.selectedType.id : null
        const idState = this.selectedFilters.selectedState ? this.selectedFilters.selectedState.id : null
        const idOperator = this.selectedFilters.selectedOperator ? this.selectedFilters.selectedOperator.id : null
        const idDevice = this.selectedFilters.selectedDevice ? this.selectedFilters.selectedDevice : null
        const idLocation = this.selectedFilters.selectedLocation ? this.selectedFilters.selectedLocation.id : null
        const idMeter = this.selectedFilters.selectedMeter ? this.selectedFilters.selectedMeter.id : null
        const idModule = this.selectedFilters.selectedModule ? this.selectedFilters.selectedModule.id : null

        let where: string = TypeHelper.emptyString
        let whereClause: string = TypeHelper.emptyString

        if (actionView != null) {
            if (columns.length == 0) {
                columns = actionView.columns.map((c: OpViewColumn) => {
                    const column: ColumnModel = new ColumnModel()
                    column.id = c.idDataType
                    column.name = c.name
                    return column
                })
            }

            const columnParams: GetViewColumnOptions = new GetViewColumnOptions(DataType.HELPER_CREATION_DATE)
            const column: OpViewColumn = actionView.getViewColumn(columnParams)

            if (column != null && fromDate != null && toDate != null) {
                whereClause += "([" + column.name + "] >= '" + fromDate + "' AND "
                whereClause += "[" + column.name + "] <= '" + toDate + "')"
            }

            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_ACTION_TYPE, idType)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_ACTION_STATUS, idState)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_OPERATOR, idOperator)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_SERIAL_NBR, idDevice)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_LOCATION, idLocation)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_METER, idMeter)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_MODULE, idModule)
        }

        where += whereClause

        if (this.$state.params['ids'] && this.$state.params['ids'].length > 0) {
            const primaryColumn: OpViewColumn = actionView.getPrimaryKeyColumn()

            if (primaryColumn != null) {
                const fColumns: ColumnModel[] = columns.filter((c: ColumnModel) => {
                    if (primaryColumn.idDataType === c.id) {
                        return true
                    }
                    return false
                })

                let where: string = '[' + primaryColumn.name + '] in (' + this.$state.params['ids'].join(',') + ')'

                if (fColumns.length > 0) {
                    const fColumn: ColumnModel = fColumns[0]

                    if (_.size(fColumn.where) === 0) {
                        fColumn.where = [where]
                    } else {
                        fColumn.where.push(where)
                    }
                } else {
                    const fColumn: ColumnModel = new ColumnModel()
                    fColumn.name = primaryColumn.name
                    fColumn.id = primaryColumn.idDataType
                    fColumn.where = [where]
                }

                if (where.length > 0) {
                    where += " and "
                }

                where += where
            }
        }

        return where
    }

    private addValueToWhereClause(actionView: OpView, whereClause: string, type: number, value: any): string {
        const columnParams: GetViewColumnOptions = new GetViewColumnOptions(type)
        const column: OpViewColumn = actionView.getViewColumn(columnParams)

        if (column != null && value != null) {
            if (whereClause.length > 0) {
                whereClause += " AND "
            }

            whereClause += "([" + column.name + "] like '" + value + "')"
        }

        return whereClause
    }

    private prepareGridObjects(objects: OpAction[], actionView: OpView): any[] {
        return _.map(objects, (action: OpAction) => {
            const item: any = this.gridService.gridObjectFromIOpObject(action)

            _.forEach(actionView.columns, (actionColumn: OpViewColumn) => {
                if (actionColumn.dataType != null && (actionColumn.dataType.idDataTypeClass == Enums.DataTypeClass.Date || actionColumn.dataType.idDataTypeClass == Enums.DataTypeClass.Datetime)) {
                    if (item[actionColumn.name.toLowerCase()] != null) {
                        item[actionColumn.name.toLowerCase()] = ConvertHelper.stringToDate(item[actionColumn.name.toLowerCase()])
                    }
                }
            })

            item.rowColor = action.dataList.getValue(Enums.DataType.HELPER_ROW_COLOR)
            item.statusId = action.idActionStatus

            let parentColumn: OpViewColumn

            if (actionView != null) {
                parentColumn = actionView.getViewColumn(new GetViewColumnOptions(Enums.DataType.HELPER_ID_ACTION_PARENT))
            }

            if (parentColumn != null && item[parentColumn.name.toLowerCase()] > 0) {
                item[this.PARENT_ID_FIELD] = item[parentColumn.name.toLowerCase()]
            } else {
                item[this.PARENT_ID_FIELD] = 0
            }

            return item
        })
    }

    private getActions(): JQueryPromise<DataProviderListResult<any>> {
        this.$scope.showGrid = false
        this.refreshFilters()


        const actionRequest: GridRequestModel = new GridRequestModel();
        actionRequest.columns = this.columns
        actionRequest.pageNumber = 1
        actionRequest.pageSize = this.pageSize

        this.saveDatesToLocalStorage()

        return this.userSession
            .getDataProvider()
            .View
            .getActiveView(Enums.ReferenceType.IdAction)
            .then((actionView: OpView) => {
                actionRequest.where = this.prepareCustomWhereClause(actionView, actionRequest.columns)

                return this.actionService
                    .getActions(actionRequest.columns.map((value: ColumnModel) => new ColumnInfo(value)), actionRequest.pageNumber, actionRequest.pageSize, actionRequest.where)
                    .then((response: DataProviderListResult<OpAction>) => {
                        const result: DataProviderListResult<OpAction> = <DataProviderListResult<OpAction>>{
                            error: response.error,
                            totalCount: response.totalCount,
                            objects: []
                        }

                        if (response != null && _.size(response.objects) > 0) {
                            if (response.totalCount > this.pageSize) {
                                ToastHelper.showInfo(LocalizationHelper.getLocalizedText('FoundTooManyRecords', { collection: 'Grid' })
                                    .replace('{0}', response.totalCount)
                                    .replace('{1}', this.pageSize), { displayTime: 4000 })
                            }

                            result.objects = this.prepareGridObjects(response.objects, actionView)
                        }

                        return result
                    })
                    .always(() => {
                        this.$scope.showGrid = true

                        if (this.actionFiltersComponent != null) {
                            this.actionFiltersComponent.disableCancelbutton()
                        }
                    })
            })
    }

    private getActionsWithTreeListRefresh(): void {
        this.dataGrid.beginCustomLoading(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Loading))

        this.getActions()
            .then((result: DataProviderListResult<any>) => {
                this.$scope.$root.$broadcast(EventsNames.UPDATE_GRID_DATASOURCE + this.treeListId, new DataSource({ store: new ArrayStore({ data: result.objects }) }))
                this.dataGrid.endCustomLoading()
            })
    }

    private clearActionFilter(filterField: any, type: Enums.SimaxOperatorLayoutSetting) {
        filterField = null
        this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(type), null)
        this.getActionsWithTreeListRefresh()

        if (this.actionFiltersComponent != null) {
            this.actionFiltersComponent.updateFilters(this.selectedFilters)
        }
    }

    private refreshFilters(): void {
        const additionalFilters: AdditionalFilter[] = []

        const dateFormat: string = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')

        this.pushToAdditionalFiltersIfExists(
            additionalFilters,
            Enums.DataType.HELPER_CREATION_DATE,
            [
                moment(this.selectedFilters.selectedFromDate, dateFormat).format(dateFormat),
                moment(this.selectedFilters.selectedToDate, dateFormat).format(dateFormat)
            ],
            ['>= ', '<= '],
            null,
            ' AND ',
            () => {
                this.resetDate()
                this.refreshFilters()
                ToastHelper.showInfo(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SetUpDefaultDateRange), { displayTime: 3000 })
                this.getActionsWithTreeListRefresh()

                if (this.actionFiltersComponent != null) {
                    this.actionFiltersComponent.updateFilters(this.selectedFilters)
                }
            })

        this.pushToAdditionalFiltersIfExists(additionalFilters, Enums.DataType.HELPER_ID_ACTION_TYPE, this.selectedFilters.selectedType, '= ', () => {
            this.clearActionFilter(this.selectedFilters.selectedType, Enums.SimaxOperatorLayoutSetting.ActionType)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, Enums.DataType.HELPER_ID_ACTION_STATUS, this.selectedFilters.selectedState, '= ', () => {
            this.clearActionFilter(this.selectedFilters.selectedState, Enums.SimaxOperatorLayoutSetting.ActionState)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, Enums.DataType.HELPER_ID_LOCATION, this.selectedFilters.selectedLocation, '= ', () => {
            this.clearActionFilter(this.selectedFilters.selectedLocation, Enums.SimaxOperatorLayoutSetting.ActionLocationId)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, Enums.DataType.HELPER_SERIAL_NBR, this.selectedFilters.selectedDevice, '= ', () => {
            this.clearActionFilter(this.selectedFilters.selectedDevice, Enums.SimaxOperatorLayoutSetting.ActionDeviceId)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, Enums.DataType.HELPER_ID_METER, this.selectedFilters.selectedMeter, '= ', () => {
            this.clearActionFilter(this.selectedFilters.selectedMeter, Enums.SimaxOperatorLayoutSetting.ActionMeterId)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, Enums.DataType.HELPER_ID_OPERATOR, this.selectedFilters.selectedOperator, '= ', () => {
            this.clearActionFilter(this.selectedFilters.selectedOperator, Enums.SimaxOperatorLayoutSetting.ActionOperator)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, Enums.DataType.HELPER_ID_MODULE, this.selectedFilters.selectedModule, '= ', () => {
            this.clearActionFilter(this.selectedFilters.selectedModule, Enums.SimaxOperatorLayoutSetting.ActionModule)
        })

        if (this.$scope.mainTreeListOptions) {
            this.$scope.mainTreeListOptions.additionalFilters = additionalFilters
        }
    }

    private pushToAdditionalFiltersIfExists(additionalFilters: any[], columnId: number, selectedValue: any, condition: string | string[], clearFilter = null, separator: string = null, catchClearFilter = null) {
        if (selectedValue == null || additionalFilters == null) {
            return
        }

        const column: ColumnModel = _.find(this.columns, (col: ColumnModel) => col.id == columnId)

        if (column != null) {
            if (_.isArray(selectedValue) && _.isArray(condition)) {
                const additionalFilter: any = []

                for (let i in selectedValue) {
                    additionalFilter.push({
                        columnName: column.caption + ' [CUSTOM_ICON=FILTERS]',
                        condition: condition[i] + (selectedValue[i].caption || selectedValue[i])
                    })
                }

                additionalFilter.separator = separator
                additionalFilter.clearFilter = clearFilter
                additionalFilter.catchClearFilter = catchClearFilter
                additionalFilters.push(additionalFilter)
            } else {
                additionalFilters.push({
                    columnName: column.caption + ' [CUSTOM_ICON=FILTERS]',
                    condition: condition + (selectedValue.caption || selectedValue),
                    clearFilter: clearFilter
                })
            }
        }
    }

    private resetDate(): void {
        const dateFormat: string = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')
        let date: Date = new Date()
        date.setHours(0, 0, 0, 0)
        const fromDate: moment.Moment = moment(date.setDate(new Date().getDate() - 6))
        this.selectedFilters.selectedFromDate = fromDate.format(dateFormat)

        date = new Date()
        date.setHours(23, 59, 59, 999)
        const toDate: moment.Moment = moment(date)
        this.selectedFilters.selectedToDate = toDate.format(dateFormat)

        this.saveDatesToLocalStorage()
    }

    private saveDatesToLocalStorage(): void {
        this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionFromDate), this.selectedFilters.selectedFromDate)
        this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ActionToDate), this.selectedFilters.selectedToDate)
    }

    private mockGetActionMethodAndRefreshGrid(): void {
        // Store standard getAction method
        const currentGetActions: () => JQueryPromise<DataProviderListResult<any>> = this.getActions

        // mock getAction method
        this.getActions = () => {
            return this.$q.resolve({}) as any
        }

        // refresh grid with mocked method to get actions
        this.getActionsWithTreeListRefresh()

        // restore getActions method
        this.getActions = currentGetActions
    }

    private drawGrid(): void {
        this.actionService
            .getMainGridColumns()
            .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                this.columns = columns

                this.getActions().then((result) => {
                    this.$scope.mainTreeListOptions = {
                        referenceId: CommonHelper.IdAction,
                        idReferenceType: Enums.ReferenceType.IdAction,
                        name: this.TREE_LIST_NAME,
                        type: GridTypes.MAIN,
                        keyExpr: 'id',
                        parentIdExpr: this.PARENT_ID_FIELD,
                        defaultColumnsDictionary: defaultColumns,
                        columnsDictionary: columns,
                        addCustomFilters: true,
                        dataSource: new DataSource({ store: result.objects, pageSize: this.pageSize }),

                        allowColumnReordering: !this.userSession
                            .getLoggedOperator()
                            .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.ActionModuleMainGrid),

                        onInitialized: (e: any, grid: TreeListController<OpAction>) => {
                            this.onTreeListInitialized(e, grid)
                        },

                        onNodesInitialized: (e: any) => {
                            this.onTreeListNodeInitialized(e)
                        },

                        onContentReady: (e: any) => {
                            this.onTreeListContentReady(e)
                        },

                        onRowDoubleClick: (e: any) => {
                            this.onShowDetails(e)
                        },

                        buttonsOptions: this.getButtonsOptions(),
                        localStorageVarForSavedEntity: "actionSaved",
                        actionFiltersOptions: {
                            onFiltersUpdateCancel: () => { this.onActionFiltersCancel() },
                            onFiltersUpdated: (selectedFilters: ActionSelectedFilters) => { this.onActionFiltersUpdated(selectedFilters) },
                            onInitialized: (e: IMRActionFiltersInitializedArgs) => {
                                this.actionFiltersComponent = e.component
                            }
                        }
                    }

                    this.$timeout(() => {
                        this.refreshFilters()
                    })
                })
            })
    }

    //#endregion   


    //#region Toast

    private changeFiltersToast: IIMRToast

    private openChangeFiltersToast(): void {
        if (this.changeFiltersToast == null) {
            this.changeFiltersToast = ToastHelper.showWarning(
                LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChangeDateRange), {
                onHidden: (e: IMRToastHiddenArgs) => {
                    this.changeFiltersToast = null
                }
            })
        }
    }

    //#endregion

    //#region Constants

    private setConstants(): void {
        this.$scope.CHANGE_FILTER_POPOVER_TEXT = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChangeFiltersPopover)
    }
    //#endregion

}

